export const selectDistanceSegmentsState = state =>
  state.poiDistanceSegmentState;
